import { useState, useEffect } from "react";
import moment from "moment";
import InputDate from "../../components/form/InputDate";
import Select from "../../components/form/select/Select";
import ModalDefault from "../../components/ModalDefault";
import api from "../../services/api";
import message from "../../services/message";
import axios from "axios";
import { Container } from "../../styles/layout";
import {
  IconAdd,
  IconArrow,
  IconDetails,
  IconEdit,
  IconFilter,
  IconRemove,
} from "../../components/layout/Svgs";

import {
  HeaderPonto,
  SectionFilterPonto,
  SectionTablePonto,

} from "./styles";
import { ContainerModal } from "../../components/layout/styles";
import { SectionModal } from "../../components/layout/styles";
import Input from "../../components/form/input/Input";





export default function ClientesListar() {

  const [modal, setModal] = useState(false);
  const [load, setLoad] = useState(false);

  const [clientes, setClientes] = useState([])
  const [newCliente, setNewCliente] = useState({
      clienteId:null,
      nome:'',
      status:'ativo'
  })

  useEffect(() => {
    getClientes()
  }, [])

  async function getClientes(){
    try{
      let response : any =  await api.get(`/cliente`)
      setClientes(response.data)
    }catch(error:any){
      message.error(String(error?.response?.data?.message));
    }
  }
  
  async function resetCliente(){
    setNewCliente({
        clienteId:null,
        nome:'',
        status:'ativo'
    })

    setModal(!modal)
  }

  function handleOnChangeNewCliente(name: string, value: string) {
    if (value) {
      setNewCliente({ ...newCliente, [name]: value });
    } else {
      setNewCliente({ ...newCliente, [name]: ''});
    }
  }

  async function editarCliente(id?: any) {
    

    try{
      if(id){
        let response = await api.get(`/cliente/${id}`)
        setNewCliente(response.data)
      }else{
        resetCliente()
      }
      
      setModal(true);
    } catch(error: any) {
      message.error(String(error?.response?.data?.message));
    }
  }

  async function saveCliente(e:any){
    try{
      e.preventDefault();
      let response : any
      if(newCliente.clienteId){
        response = await api.put(`/cliente/${newCliente.clienteId}`,newCliente)
        message.success(`Cliente Editado com Sucesso.`)
      }else{
        response = await api.post(`/cliente`, newCliente)
        message.success(`Cliente Criado com sucesso`)
      }
      await getClientes()
      resetCliente()
      setModal(!modal)
    }catch(error:any){
      message.error(String(error?.response?.data?.message));
    }
  }


  async function excluirCliente(id:number){
    try{
      let response : any = await api.delete(`/cliente/${id}`)
      getClientes()

      message.success(`Cliente Excluido com Sucesso.`)
    
    }catch(error:any){
      message.error(String(error?.response?.data?.message));
    }
  }


  return (
    <Container>
      <HeaderPonto>
        <h1 className="titlePonto">Clientes</h1>
        <button
          style={{ margin: "0px", width: "100px", letterSpacing: "1px",verticalAlign:'middle' }}
          className="btn btn-primary"
          onClick={() => editarCliente()}
        > 
          Adicionar 
          <i className="fa-solid fa-plus"></i>
        </button>
      </HeaderPonto>



      <SectionTablePonto>
        <table className="default">
          <thead>
            <tr>
              <th>Cliente</th>
              <th>Editar</th>
              <th>Remover</th>
              
            </tr>
          </thead>

          <tbody>

              { clientes && clientes.length > 0 &&
                clientes.map((row:any, key:any) =>(
                  <tr key={key}>
        
                    <td>{row.nome}</td>
                    <td>

                      <button
                        className="btn"
                        onClick={() => editarCliente(row.clienteId)}
                      >
                        <IconEdit />
                      </button>
                    </td>
                    <td>
                      <button
                        className="btn"
                        onClick={() => excluirCliente(row.clienteId)}
                      >
                        <IconRemove />
                      </button>
                    </td>
                  </tr>
                ))
              }
              
          
          </tbody>
        </table>
      </SectionTablePonto>




      <ModalDefault
        id="modalDefault"
        onClose={() => {resetCliente()}}
        visible={modal}
      >
        <ContainerModal>
          <SectionModal>
            <h1>Editar / Adicionar - Cliente</h1>
            <form onSubmit={saveCliente}>
              <div className="field">
                <h4>Nome</h4>
                <div className="input">
                  <Input type="text" name="nome" value={newCliente?.nome} onChange={handleOnChangeNewCliente}/>
                </div>
              </div>

              <div className="actions">
                <button type="submit" className="btn btn-success">Salvar</button>
                <button type="button" onClick={() => resetCliente()} className="btn btn-danger">Voltar</button>
              </div>
            </form>
          </SectionModal>
            <button
              className="buttonClosePreview"
              onClick={() => resetCliente()}
            >
              <IconRemove width="22px" height="22px" />
              Fechar modal
            </button>
        </ContainerModal>

      </ModalDefault>
    </Container>
  );
}
